<template>
  <div>
    <v-app-bar
      class="header-mobile"
      color="white"
      elevate-on-scroll
      :height="xsOnly ? '64px' : '80px'"
      tile
      app
    >
      <div class="d-flex align-center">
        <router-link to="/">
          <img
            v-if="informations.img"
            class="d-block"
            :src="files + informations.img"
            :alt="informations.name"
            :height="xsOnly ? '46px' : '70px'"
          />
        </router-link>

        <div
          v-if="
            !xsOnly && (informations.img_faculty || informations.img_foundation)
          "
          class="d-flex flex-column ml-6"
        >
          <v-card
            v-if="informations.img_faculty"
            v-bind="getLinkAttrs(externalLinks.college_website)"
            flat
            tile
          >
            <img
              class="d-block"
              :src="files + informations.img_faculty"
              width="90px"
            />
          </v-card>

          <v-card
            v-if="informations.img_foundation"
            :class="{ 'mt-2': informations.img_faculty }"
            v-bind="getLinkAttrs(externalLinks.foundation_website)"
            flat
            tile
          >
            <img
              class="d-block"
              :src="files + informations.img_foundation"
              width="90px"
            />
          </v-card>
        </div>
      </div>

      <v-spacer />

      <v-app-bar-nav-icon color="primary" @click="showNavigationDrawer" />
    </v-app-bar>
  </div>
</template>

<script>
import { getLinkAttrs } from "../../../utils/getLinkAttrs";

export default {
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    externalLinks() {
      return this.$rest("external-links").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getLinkAttrs,
    showNavigationDrawer() {
      window.showNavigationDrawer();
    },
  },
};
</script>
